import { AlertCircle, FileWarning } from "lucide-react"
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom"
import { cn } from "@/shared/lib/utils.ts"
import { Button } from "@/shared/ui/button"

export default function ErrorPage() {
  const navigate = useNavigate()
  const error = useRouteError()

  const is404 = isRouteErrorResponse(error) && error.status === 404
  const title = is404 ? "Страница не найдена" : "Что-то пошло не так"
  const message = isRouteErrorResponse(error)
    ? error.data?.message || error.statusText
    : error instanceof Error
      ? error.message
      : "Неизвестная ошибка"

  const Icon = is404 ? FileWarning : AlertCircle

  return (
    <div className={cn("inset-0 z-50 flex h-full flex-col items-center justify-center gap-6 bg-background/80 p-6 text-center backdrop-blur-md")}>
      {/* Icon */}
      <Icon className="h-16 w-16 text-destructive" />

      {/* Title */}
      <h1 className="font-bold text-3xl text-foreground">{title}</h1>

      {/* Message */}
      <p className="max-w-md rounded-md bg-red-100 p-4 px-6 text-muted-foreground text-red-700">{message}</p>

      {/* Action */}
      <div className="flex gap-2">
        <Button onClick={() => navigate(-1)}>Назад</Button>
        <Button onClick={() => navigate("/")}>На главную</Button>
      </div>
    </div>
  )
}
